import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const checklistForm: Form<Client> = {
  key: 'checklist',
  title: 'Wurde folgendes mit der Klientin vorab besprochen?',
  fields: [
    {
      key: 'generalConditions',
      label: 'Rahmenbedingungen der BST/ISTE',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'mission',
      label: 'Auftrag der BST/ISTE',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'dutyOfConfidentiality',
      label:
        'Schweigepflicht unsererseits (mit folgenden Ausnahmen: innerhalb ' +
        'des Teams zur Vertretung, Fallbesprechung und bei akuten ' +
        'Notsituationen wie Kindeswohlgefährdung, Selbst- oder Fremdgefährdung)',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'lackOfRightToRefuseToTestify',
      label: 'fehlendes Zeugnisverweigerungsrecht',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'dataPrivacy',
      label:
        'Datenschutz (Daten werden sensibel und vertraulich behandelt ' +
        'à Genaueres ist auf der Website zu finden oder kann per Mail ' +
        'zugesendet werden !!Mails sind nicht geschützt und werden nur ' +
        'im Einverständnis der Klientin übersendet!!)',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'dataStorage',
      label: 'Erlaubnis zur Datenspeicherung über den aktiven Beratungsverlauf hinaus wurde schriftlich erteilt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'recordAccompanyingPersons',
      label:
        'Bei Vereinbarungen persönlicher Termine müssen eventuelle ' +
        'Begleitpersonen namentlich bei der BST hinterlegt werden ' +
        '(Begründung: Sicherheitskonzept und Schleuseàevtl. auf ' +
        'Ausweiskontrolle hinweisen bezgl. der Schutzeinrichtung Frauenhaus)',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'dogPresent',
      label: 'ggf. Information/Abklärung, ob Hund bei pers. Beratung anwesend sein darf ',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
  ],
};

export default checklistForm;
